import useQueryDevelopment from '@hooks/useQueryDevelopment'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import { RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const AboutDevelopment_1 = ({ developmentID, global_data }: CombinedProps) => {
  const { data: allDevelopmentData } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  return (
    <section
      className={'development-text text-center a p-y-config'}
      id="Proyecto"
    >
      <Container>
        <Row>
          <Col>
            <h2>{allDevelopmentData?.publication_title || 'Cargando...'}</h2>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutDevelopment_1
